import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    margin: '12 0',
    '& > span:not(:last-child)': {
      borderRight: `1px solid ${theme.KPI.KPIButton}`,
      marginRight: '8px'
    }
  },
  label: {
    color: theme.printTableLabel,
    fontWeight: 600,
    lineHeight: "16px",
    marginRight: 12,
    whiteSpace: 'nowrap',
  },
});

const StatusBar = ({ classes, kpiData }) => {
  return (
    <div className={classes.container}>
      {kpiData?.map((kpiLabel) => (
        <span className={classes.label}>{kpiLabel}</span>
      ))}
    </div>
  );
};

export default withStyles(styles)(StatusBar);
